<template>
    <div class="room__controls">
        <video-switch></video-switch>
        <end></end>
        <mic-switch></mic-switch>
        <refresh></refresh>
    </div>
</template>

<script>
    import VideoSwitch from "./VideoSwitch";
    import MicSwitch from "./MicSwitch";
    import End from './End';
    import Refresh from "./Refresh";

    export default {
        name: "Controls",
        components: {
            VideoSwitch,
            End,
            MicSwitch,
            Refresh
        },
    }
</script>
